const topicTags = [
  { id: 1, name: '热血少年漫', count: '2.3万讨论', hot: true },
  { id: 2, name: '恋爱少女漫', count: '1.8万讨论', hot: true },
  { id: 3, name: '悬疑恐怖漫', count: '1.2万讨论', hot: false },
  { id: 4, name: '搞笑四格漫', count: '9800讨论', hot: false },
  { id: 5, name: '奇幻冒险漫', count: '2.1万讨论', hot: true },
  { id: 6, name: '治愈日常漫', count: '1.5万讨论', hot: false },
  { id: 7, name: '科幻机甲漫', count: '8700讨论', hot: false },
  { id: 8, name: '武侠仙侠漫', count: '1.6万讨论', hot: true },
  { id: 9, name: '体育竞技漫', count: '7500讨论', hot: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            51漫画下载爱好者都在讨论的热门题材，发现您感兴趣的漫画话题
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicTags.map((tag) => (
            <a
              key={tag.id}
              href="#index"
              className="group flex items-center gap-2.5 px-5 py-3 bg-background-50 hover:bg-primary-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              {tag.hot && (
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-fire-line text-accent-500 text-sm"></i>
                </div>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 whitespace-nowrap">
                {tag.name}
              </span>
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                {tag.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}